import * as React from 'react'
import StandardInput from '../../common/components/standard-input'
import SelectionInput from '../../common/components/selection-input'
import YesNoInput from '../../common/components/yes-no-input'
import Validation from '../../common/modules/validation/rules'
import Alert from '../../common/components/alert'
import { mapValues } from 'lodash'
import * as moment from 'moment'
import QuoteNumber from '../../common/components/quote-number'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import yesNoOptions from '../../common/options/yes-no-options'
import InputField from '../../common/components/input-field'
import { merge, keys, pick } from 'lodash'
import { withConfig } from  '../../common/modules/config'
import { toCurrency } from '../../common/util'
import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withFields } from '../../common/modules/fields'
import { withProductData } from '../../common/modules/product-data'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { withState } from '../../common/modules/state'


export const formConfig = state => {
    const fields = state.fields;
    const productData = state.productData;

    return {
        predicates:{
            "propertyContact.fullName":        fields.selfManaged == true,
            "propertyContact.phone":           fields.selfManaged == true,
            "propertyContact.email":           fields.selfManaged == true,
            "strataManagementCompanyName":     fields.selfManaged == false, 
            "strataManagerContact.fullName":   fields.selfManaged == false,
            "strataManagerContact.email":      fields.selfManaged == false,
            "strataManagerContact.phone":      fields.selfManaged == false,
        },
        rules:{
            numberOfLifts:[
                Validation.enforce.required("Please enter the number of lifts"),
                Validation.enforce.rangeInclusive(0, 15, "Must be between 0 and 15"),
                Validation.enforce.number("The number must be a whole number"),
            ],
            numberOfPoolsOrSpas:[
                Validation.enforce.required("Please enter the number of pools or spas"),
                Validation.enforce.rangeInclusive(0, 15, "Must be between 0 and 15"),
                Validation.enforce.number("The number must be a whole number"),
            ],
            hasPlayground:[
                Validation.enforce.required("Please answer the question"),
            ],
            jettyWharfPontoonMarina:[
                Validation.enforce.required("Please answer the question"),
            ],
            lakePondWaterway:[
                Validation.enforce.required("Please answer the question"),
            ],
            gymUsedByPublic:[
                Validation.enforce.required("Please answer the question"),
            ],
            fullyOccupied:[
                Validation.enforce.required("Please answer the question"),
            ],
            groundFloorOccupancy:[
                Validation.enforce.required("Please select a value"),
            ],
            fireExtinguishers:[
                Validation.enforce.required("Please answer the question"),
            ],
            fireHydrantsHoseReels:[
                Validation.enforce.required("Please answer the question"),
            ],
            fireAlarm:[
                Validation.enforce.required("Please answer the question"),
            ],
            sprinklersLocation:[
                Validation.enforce.required("Please select a value"),
            ],
            strataManagementCompanyName:[
                Validation.enforce.required("Please enter a company name"),
            ],
            "propertyContact.fullName":[
                Validation.enforce.required("Please enter a name"),
                Validation.enforce.name("Must be a name")
            ],
            "propertyContact.email":[
                Validation.enforce.required("Please provide a valid email"),
                Validation.enforce.email("Must be an email")
            ],
            "propertyContact.phone":[
                Validation.enforce.required("Please provide a valid phone number"),
            ],
            "strataManagerContact.fullName":[
                Validation.enforce.required("Please enter a name"),
                Validation.enforce.name("Must be a name")
            ],
            "strataManagerContact.email":[
                Validation.enforce.required("Please provide a valid email"),
                Validation.enforce.email("Must be an email")
            ],
            "strataManagerContact.phone":[
                Validation.enforce.required("Please provide a valid phone number"),
            ],
        },
        inferred:{},
        options: {
            groundFloorOccupancy: productData.productOptions.OCCUPANCY,
            sprinklersLocation: productData.productOptions.SPRINKLERS,
            jettyWharfPontoonMarina: yesNoOptions,
            hasPlayground: yesNoOptions,
            lakePondWaterway: yesNoOptions,
            gymUsedByPublic: yesNoOptions,
            fullyOccupied: yesNoOptions,
            fireExtinguishers: yesNoOptions,
            fireHydrantsHoseReels: yesNoOptions,
            fireAlarm: yesNoOptions,
        },
        transformOut: data => ({
            ...data,
            step: "/step-7"
        }),
    }
}


@withSubmission
@withNavigation
@withProductData
@withValidation
@withFields
@withRouteBlocker
@withScrollToTop
@withForm(formConfig)
export default class extends React.Component<any, any> {


    render() {
        return (
            <div className="row">
                <StepTitle>Tell Us More About Your Building Details</StepTitle>
                <QuoteNumber />

                <InputField     field="numberOfLifts"                    type="Number"       label="Number of lifts in the building"                                               />
                <InputField     field="numberOfPoolsOrSpas"              type="Number"       label="Number of pools or spas"                                                       />
                <InputField     field="hasPlayground"                                        label="Is there a playground?"                                                        />
                <InputField     field="jettyWharfPontoonMarina"                              label="Is there a jetty, wharf, pontoon, or marina?"                                  />
                <InputField     field="lakePondWaterway"                                     label="Does the property contain a lake, pond, or waterway?"                          />
                <InputField     field="gymUsedByPublic"                                      label="If there is a gymnasium, is it used by the public?"                            />
                <InputField     field="fullyOccupied"                                        label="Is it fully occupied?"                                                         />
                <InputField     field="groundFloorOccupancy"                                 label="What type of occupancy is on the ground floor?"          inline={true}         />
                
                <SubHeader>Building fire protection</SubHeader>

                <InputField      field="fireExtinguishers"                                   label="Does the building have fire extinguishers?"                                    />
                <InputField      field="fireHydrantsHoseReels"                               label="Does the building have fire hydrants or hose reels?"                           />
                <InputField      field="fireAlarm"                                           label="Does the building have fire alarms?"                                           />
                <InputField      field="sprinklersLocation"                                  label="Are there sprinklers in the building?"                   inline={true}         />
                
                <SubHeader>Who is your building contact</SubHeader>
                
                <InputField     field="propertyContact.fullName"                             label="Who can we contact at the property?"                     inline={false}        />
                { this.props.fields.selfManaged && <div className="col-sm-1"></div> }
                <InputField     field="propertyContact.phone"                                label="Their phone number"                                      inline={false}     description="Please include area code if you're providing a landline e.g. 0298765432" />
                <InputField     field="propertyContact.email"                                label="Property contact email"                                  inline={false}        />
                <InputField     field="strataManagementCompanyName"                          label="Strata Management Company Name"                          inline={false}        />
                <InputField     field="strataManagerContact.fullName"                        label="Strata Manager Full Name"                                inline={false}        />
                <InputField     field="strataManagerContact.phone"                           label="Strata Manager Phone"                                    inline={false}     description="Please include area code if you're providing a landline e.g. 0298765432" />
                <InputField     field="strataManagerContact.email"                           label="Strata Manager email"                                    inline={false}        />
                

                <Button.Container>
                    <Button.Back route="/step-6" /> <Button.Save onClick={ this.save.bind(this) }/> <Button.Continue onClick={ this.onContinue.bind(this)} />
                </Button.Container>
            </div>

        )
    }

     
    save(){
       this.props.actions.submission.save("/step-7", [
            require("./step-1").formConfig,
            require("./step-2").formConfig,
            require("./step-3").formConfig,
            require("./step-4").formConfig,
            require("./step-5").formConfig,
            require("./step-6").formConfig,
            require("./step-7").formConfig,
        ]);
    }
    

    onContinue(){
        this.props.actions.validation.validate( this.submit.bind(this) );
    }

    
    submit(){
        const endpoint = this.props.submission.endpoints.flatQuote
        this.props.actions.submission.submit(endpoint, this.proceed.bind(this), [
            require("./step-1").formConfig,
            require("./step-2").formConfig,
            require("./step-3").formConfig,
            require("./step-4").formConfig,
            require("./step-5").formConfig,
            require("./step-6").formConfig,
            require("./step-7").formConfig,
        ])
    }


    proceed(){
        this.props.actions.navigation.changeRoute("/step-8");
    }


}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/routes/step-7.tsx